import React, { useEffect } from "react";
import GridContainer from "@jumbo/components/GridContainer";
import { Box, Grid, Paper } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { makeStyles } from "@material-ui/core/styles";
import VpnKeyIcon from "@material-ui/icons/VpnKey";
import DateRangeIcon from "@material-ui/icons/DateRange";
import moment from "jalali-moment";
import { baseUrl } from "@jumbo/constants/baseUrl";
import HubbleRequests from "services/hubble";

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: "100%",
    maxWidth: "300px",
  },
  formTitleContainer: {
    padding: "1rem",
    fontWeight: "bold",
    fontSize: "17px",
    color: theme.palette.primary.main,
  },
  Title: {
    padding: "0.8rem",
    backgroundColor: theme.palette.grey[200],
    fontWeight: "bold",
  },
  userInput: {
    padding: "0.8rem",
    fontWeight: "bold",
    minHeight: "45.61px",
  },
}));

const HubbleDetailsContainer = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { hubbleForm } = useSelector(({ hubble }) => hubble);
  const { id } = useParams();

  useEffect(() => {
    dispatch(HubbleRequests.getHubbleFormById(id));
  }, [id, dispatch]);

  const getLevel = (level) => {
    let lev = "انتخابی";
    if (level === "level1") {
      lev = "انتخابی";
    } else if (level === "level2") {
      lev = "مقدماتی";
    } else if (level === "level3") {
      lev = "نیمه نهایی";
    } else if (level === "level4") {
      lev = "نهایی";
    }
    return lev;
  };

  return (
    <GridContainer>
      <Grid item md={8} xs={12}>
        <Paper>
          <Box className={classes.formTitleContainer}>{hubbleForm?.major}</Box>
          <Box className={classes.Title}>نام ارسال کننده</Box>
          <Box className={classes.userInput}>{hubbleForm?.owner?.fullName}</Box>
          <Box className={classes.Title}>کد ملی ارسال کننده</Box>
          <Box className={classes.userInput}>
            {hubbleForm?.owner?.nationalCode}
          </Box>
          <Box className={classes.Title}>کد پرسنلی ارسال کننده</Box>
          <Box className={classes.userInput}>
            {hubbleForm?.owner?.personnelCode}
          </Box>
          <Box className={classes.Title}>توضیحات</Box>
          <Box className={classes.userInput}>{hubbleForm?.description}</Box>
          <Box className={classes.Title}>آدرس</Box>
          <Box className={classes.userInput}>
            {hubbleForm?.personal?.address}
          </Box>
          <Box className={classes.Title}>شهر</Box>
          <Box className={classes.userInput}>{hubbleForm?.personal?.city}</Box>
          <Box className={classes.Title}>استان</Box>
          <Box className={classes.userInput}>
            {hubbleForm?.personal?.state || "تعیین نشده"}
          </Box>
          <Box className={classes.Title}>محل کار صاحب کد پرسنلی</Box>
          <Box className={classes.userInput}>
            {hubbleForm?.personal?.workplace || "تعیین نشده"}
          </Box>
          <Box className={classes.Title}> شغل </Box>
          <Box className={classes.userInput}>
            {hubbleForm?.personal?.ownerJob || "تعیین نشده"}
          </Box>
          <Box className={classes.Title}> جنسیت </Box>
          <Box className={classes.userInput}>
            {hubbleForm?.personal?.gender === "male" ? "مرد" : "زن"}
          </Box>
          <Box className={classes.Title}>مرحله</Box>
          <Box className={classes.userInput}>{getLevel(hubbleForm?.level)}</Box>
          {hubbleForm?.groupMode && (
            <>
              <Box className={classes.Title}>نام گروه</Box>
              <Box className={classes.userInput}>{hubbleForm?.groupName}</Box>

              <Box className={classes.Title}>اعضای گروه</Box>
              <Box className={classes.userInput}>
                {hubbleForm?.groupUsers.map((item, index) => {
                  return (
                    <Box key={index}>
                      {item.fullName + " - " + item.nationalCode}
                    </Box>
                  );
                })}
              </Box>
            </>
          )}
          <Box className={classes.Title}>فایل </Box>
          <Box className={classes.userInput}>
            <a
              href={`${baseUrl}file/get/${hubbleForm?.file}`}
              target="_blank"
            >{`${baseUrl}file/get/${hubbleForm?.file}`}</a>
          </Box>
        </Paper>
      </Grid>
      <Grid item md={4} xs={12}>
        <Paper elevation={3}>
          <Box className={classes.formTitleContainer}>جزئیات تیکت</Box>
          <Box className={classes.Title}>
            <Box display={"flex"} alignItems={"center"}>
              <VpnKeyIcon style={{ marginLeft: "5px" }} />
              شناسه :
            </Box>
          </Box>
          <Box className={classes.userInput} textAlign={"right"}>
            {hubbleForm?._id}
          </Box>
          <Box className={classes.Title}>
            <Box display={"flex"} alignItems={"center"}>
              <DateRangeIcon style={{ marginLeft: "5px" }} />
              تاریخ ارسال :
            </Box>
          </Box>
          <Box className={classes.userInput} textAlign={"right"}>
            {hubbleForm
              ? moment(hubbleForm.createdAt)
                  .locale("fa")
                  .format("HH:mm:ss  YYYY/MM/DD ")
              : null}
          </Box>
          <Box className={classes.Title}>
            <Box display={"flex"} alignItems={"center"}>
              <DateRangeIcon style={{ marginLeft: "5px" }} />
              تاریخ به‌روز‌رسانی :
            </Box>
          </Box>
          <Box className={classes.userInput} textAlign={"right"}>
            {hubbleForm
              ? moment(hubbleForm.updatedAt)
                  .locale("fa")
                  .format("HH:mm:ss  YYYY/MM/DD ")
              : null}
          </Box>
        </Paper>
      </Grid>
    </GridContainer>
  );
};

export default HubbleDetailsContainer;
